import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import HeartIcon from 'mdi-react/HeartIcon';
import HeartOutlineIcon from 'mdi-react/HeartOutlineIcon';
import BellIcon from 'mdi-react/BellIcon';
import BellOutlineIcon from 'mdi-react/BellOutlineIcon';
import CompareIcon from 'mdi-react/ScaleBalanceIcon';
import { AppContext } from '@prisjakt/ui-app-context';
import Dropdown from '@prisjakt/ui-dropdown';

import LoginPromoModal from '../../../../../../components/modal/login-promo';
import alertActions from '../../../../../sidebar/actions/alert';
import listActions from '../../../../../sidebar/actions/lists';

import * as S from './styles';

class ProductActionButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Highlights the heart if the product was recently added to a list.
      // Kind of an ugly hack; should be fixed once we can get this information
      // from GraphQL.
      addedToList: false,
    };
  }

  addToList() {
    this.props.onAction('list-add');
    this.props.addListItemRequest(this.props.product, this.props.isDesktop);
    this.setState({ addedToList: true });
  }

  render() {
    const { props, context, state } = this;
    const { t, linkTo } = context;
    const {
      className,
      product,
      account,
      onAction,
      selectList,
      openAlerts,
      horizontal,
      buttonStyle,
    } = props;
    const { addedToList } = state;
    const {
      createdAlerts,
      deletedAlerts,
      createdLists,
      deletedLists,
      selectedList,
    } = props.listAlert;
    const { me, isAuthenticated } = account || {};
    let alertId = product.alert ? product.alert.id : null;
    if (deletedAlerts[alertId]) {
      alertId = null;
    }
    if (createdAlerts[product.id]) {
      alertId = createdAlerts[product.id];
    }

    const latestLists =
      me &&
      me.lists &&
      [...createdLists, ...me.lists.nodes]
        .filter(list => deletedLists[list.id] !== true)
        .sort(a => {
          if (a.id === selectedList) {
            return 1;
          }

          return 0;
        });

    const listsButton = component => (
      <S.ActionButton buttonStyle={buttonStyle} data-test="SaveToListButton">
        <S.Tooltip
          title={t('product', 'action-button.list-tooltip')}
          width={180}
        >
          <S.Button
            buttonStyle={buttonStyle}
            variant={buttonStyle === 'circle' ? 'iconOutlined' : 'outlined'}
            size={buttonStyle === 'circle' ? 'medium' : 'small'}
            color={
              addedToList && buttonStyle === 'square' ? 'positive' : 'primary'
            }
            icon={<HeartIcon />}
            iconOutlined={<HeartOutlineIcon />}
            active={!!addedToList}
            component={component}
            ariaLabel={t('common', 'button.save')}
            onClick={e => {
              // Promote login/create account if user not logged in
              if (!isAuthenticated) {
                this.setState({
                  showLoginPromo: true,
                });

                return;
              }

              // If user has not selected any list
              // open drop down and run same actions
              if (latestLists.length > 0) {
                return;
              }

              e.stopPropagation();
              this.addToList();
            }}
          >
            <S.ButtonText>{t('common', 'button.save')}</S.ButtonText>
          </S.Button>
        </S.Tooltip>
      </S.ActionButton>
    );
    return (
      <S.ProductActionButtons
        buttonStyle={buttonStyle}
        horizontal={horizontal}
        className={className}
      >
        {isAuthenticated ? (
          <S.ListsDropdown
            type="select-box-independent-type"
            options={latestLists}
            onSelect={option => {
              selectList(option.id);
              this.addToList();
            }}
            offsetOrigin="right"
            offset={{ x: 0, y: -5 }}
            title={listsButton(<div />)}
          />
        ) : (
          <>
            {this.state.showLoginPromo && (
              <LoginPromoModal
                isOpen={this.state.showLoginPromo}
                onRequestClose={() => this.setState({ showLoginPromo: false })}
              />
            )}
            {listsButton()}
          </>
        )}

        {alertId && isAuthenticated ? (
          <Dropdown
            divider
            type="select-box-independent-type"
            options={[
              {
                name: t('product', 'alert.delete-button'),
                value: 'ALERT_REMOVE',
              },
              {
                name: t('product', 'alert.edit-button'),
                value: 'ALERT_EDIT',
              },
            ]}
            title={
              <S.ActionButton data-test="CreateAlertButton">
                <S.Tooltip
                  title={t('product', 'action-button.alert-tooltip')}
                  horizontal={horizontal}
                  width={180}
                >
                  <S.Button
                    buttonStyle={buttonStyle}
                    variant={
                      buttonStyle === 'circle' ? 'iconOutlined' : 'outlined'
                    }
                    size={buttonStyle === 'circle' ? 'medium' : 'small'}
                    color={buttonStyle === 'circle' ? 'primary' : 'positive'}
                    active
                    icon={<BellIcon height={20} />}
                    iconOutlined={<BellOutlineIcon height={20} />}
                    component={<div />}
                  >
                    <S.ButtonText>
                      {t('product', 'alert.create-button')}
                    </S.ButtonText>
                  </S.Button>
                </S.Tooltip>
              </S.ActionButton>
            }
            onSelect={option => {
              switch (option.value) {
                case 'ALERT_REMOVE': {
                  onAction('alert-remove');
                  openAlerts();
                  props.removeAlertRequest(alertId, product.id);
                  break;
                }
                case 'ALERT_EDIT': {
                  openAlerts();
                  onAction('alert-create');
                  break;
                }
                default:
              }
            }}
            offsetOrigin="right"
            offset={{ x: 0, y: -5 }}
          />
        ) : (
          <S.ActionButton
            buttonStyle={buttonStyle}
            data-test="CreateAlertButton"
          >
            <S.Tooltip
              title={t('product', 'action-button.alert-tooltip')}
              width={180}
            >
              <S.Button
                buttonStyle={buttonStyle}
                color="primary"
                variant={buttonStyle === 'circle' ? 'iconOutlined' : 'outlined'}
                size={buttonStyle === 'circle' ? 'medium' : 'small'}
                icon={<BellIcon height={20} />}
                iconOutlined={<BellOutlineIcon height={20} />}
                component={<div />}
                ariaLabel={t('product', 'alert.create-button')}
                onClick={() => {
                  onAction('alert-create');
                }}
              >
                <S.ButtonText>
                  {t('product', 'alert.create-button')}
                </S.ButtonText>
              </S.Button>
            </S.Tooltip>
          </S.ActionButton>
        )}

        <S.ActionButton buttonStyle={buttonStyle} data-test="CompareButton">
          <S.Tooltip
            title={t('product', 'action-button.compare-tooltip')}
            width={180}
            isMarginRight={horizontal}
          >
            <S.Button
              buttonStyle={buttonStyle}
              variant={buttonStyle === 'circle' ? 'iconOutlined' : 'outlined'}
              size={buttonStyle === 'circle' ? 'medium' : 'small'}
              color="primary"
              icon={<CompareIcon size={20} />}
              iconOutlined={<CompareIcon size={20} />}
              ariaLabel={t('product', 'product-compare.compare')}
              component={
                <Link
                  to={linkTo('productCompare', {
                    category: product.category,
                    products: [product],
                  })}
                />
              }
            >
              <S.ButtonText>
                {t('product', 'product-compare.compare')}
              </S.ButtonText>
            </S.Button>
          </S.Tooltip>
        </S.ActionButton>
      </S.ProductActionButtons>
    );
  }
}

const { func, shape, number, string, object, bool } = PropTypes;

ProductActionButtons.propTypes = {
  className: string,
  product: shape({
    id: number,
    alertId: number,
    stockStatus: string,
    pathName: string,
    category: object,
  }),
  account: shape({
    me: object,
    isAuthenticated: bool,
  }),
  listAlert: shape({
    createdAlerts: object, // eslint-disable-line react/forbid-prop-types
    deletedAlerts: object, // eslint-disable-line react/forbid-prop-types
  }),
  createAlertRequest: func.isRequired,
  removeAlertRequest: func.isRequired,
  addListItemRequest: func.isRequired,
  onAction: func,
  horizontal: bool,
  isDesktop: bool,
  buttonStyle: string,
};

ProductActionButtons.defaultProps = {
  className: undefined,
  product: {},
  account: {
    me: undefined,
    isAuthenticated: false,
  },
  listAlert: {
    createdAlerts: {},
    deletedAlerts: {},
  },
  onAction: () => {},
  horizontal: false,
  isDesktop: false,
  buttonStyle: 'square',
};

ProductActionButtons.contextType = AppContext;

export default connect(
  state => ({
    account: state.areas.account,
    listAlert: state.areas.sidebar,
  }),
  { ...alertActions, ...listActions }
)(ProductActionButtons);
